import styled from '@emotion/styled'

import { mq } from '../../constants/breakpoints'

export const FilterInputStyles = styled.div`
  min-width: 200px;
  font-size: 0.8rem;
  position: relative;

  ul {
    position: absolute;
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    border-width: 0 1px 1px 1px;
    border-radius: 0 0 3px 3px;
    border-color: black;
    border-style: solid;
    background-color: white;
    z-index: 10;
    margin-top: -1px;
    max-height: 200px;
    overflow: auto;
  }

  li {
    cursor: pointer;
    padding: 10px 10px;

    &:last-child {
      border-radius: 0 0 3px 3px;
    }
  }

  label {
    display: block;
    margin-bottom: 5px;
  }

  ${mq.mobile} {
    width: 100%;
  }
`

export const InputContainer = styled.div<{ listVisible: boolean; disabled: boolean }>`
  background-color: white;
  display: flex;
  align-items: center;
  border: 1px solid ${(props) => (props.disabled ? '#DDDDDD' : 'black')};
  border-bottom-color: ${(props) => (props.listVisible ? 'transparent' : null)};
  border-radius: ${(props) => (props.listVisible ? '3px 3px 0 0' : '3px')};
  height: 30px;
  font-size: 0.8rem;
  width: 100%;

  input {
    border: none;
    flex: 1;
    border-radius: 3px;
    height: 100%;
    outline: none;
    padding-left: 10px;
    background-color: white;
  }

  button {
    padding: 0 10px;
    height: 100%;
    outline: none;
    color: ${(props) => (props.disabled ? '#DDDDDD' : 'black')};
  }
`
